import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialBlockTwitterIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialBlockTwitter",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.99 24.75A5.3 5.3 0 0 1 24.75 30H7.24c-2.88-.04-5.21-2.37-5.24-5.24V7.25A5.31 5.31 0 0 1 7.23 2h17.5a5.3 5.3 0 0 1 5.25 5.24v17.51zm-6.86-13.36c.79-.48 1.39-1.22 1.69-2.09v-.03c-.69.42-1.51.74-2.38.92h-.05c-.7-.74-1.69-1.2-2.79-1.2-2.1 0-3.81 1.7-3.82 3.81s0 .06 0 .09c0 .28.03.55.1.81v-.02c-3.2-.15-6.02-1.67-7.9-3.98l-.02-.02c-.34.55-.54 1.23-.54 1.94v.04c0 1.3.65 2.45 1.64 3.14h.01c-.67-.02-1.28-.19-1.84-.47h.03a3.916 3.916 0 0 0 3.16 3.77h.02c-.27.09-.58.14-.9.14h-.03c-.25 0-.49-.03-.73-.08h.03c.5 1.54 1.9 2.63 3.56 2.65a7.67 7.67 0 0 1-4.75 1.63h-.01c-.32 0-.64-.02-.95-.07h.04c1.66 1.08 3.69 1.72 5.86 1.72h.02c5.98 0 10.82-4.85 10.82-10.82v-.49c.76-.53 1.39-1.19 1.89-1.95l.02-.03a7.7 7.7 0 0 1-2.17.6h-.04l.01-.02Z"
    })
  }));
};